import axios from '../utils/axios';

export default function fetchUserAppliedJobs (adminId, params) {
    return axios.get(`/admin/${adminId}/user-applied-jobs`, { params });
}